<template>
  <b-form-checkbox
      v-model.number="internalValue"
      value="1"
      unchecked-value="0"
  >
    {{ $t('Show deleted') }}
  </b-form-checkbox>
</template>
<script>
export default {
  name: 'ShowDeletedItems',
  props: {
    value: {
      type: Number,
      default: 0
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
